export const userTypeOptions = [
  { value: 'fpigi_primary_Controller_Email;fpigi_primary_Controller_Name;fpigi_primary_Controller_Phone', name: 'Controller' },
  { value: 'fpigi_primary_accountingManager_Email;fpigi_primary_accountingManager_Name;fpigi_primary_accountingManager_Phone', name: 'Accounting Manager' },
  { value: 'fpigi_primary_Implementation_Contact_Email;fpigi_primary_Implementation_Contact_Name;fpigi_primary_Implementation_Contact_Phone', name: 'Primary Implementation Contact' },
  { value: 'fpigi_president_or_ceo_Email;fpigi_president_or_ceo_Name;fpigi_president_or_ceo_Phone', name: 'President/CEO' },
  { value: 'fpigi_CNO_Email;fpigi_CNO_Name;fpigi_CNO_Phone', name: 'CNO' },
  { value: 'fpigi_CMO_Email;fpigi_CMO_Name;fpigi_CMO_Phone', name: 'CMO' },
  { value: 'fpigi_ER_Medical_Director_Email;fpigi_ER_Medical_Director_Name;fpigi_ER_Medical_Director_Phone', name: 'ER Medical Director' },
  { value: 'fpigi_Neuro_Medical_Director_Email;fpigi_Neuro_Medical_Director_Name;fpigi_Neuro_Medical_Director_Phone', name: 'Neuro Medical Director' },
  { value: 'fpigi_ER_Director_Email;fpigi_ER_Director_Name;fpigi_ER_Director_Phone', name: 'ER Director' },
  { value: 'fpigi_Stroke_Coordinator_Email;fpigi_Stroke_Coordinator_Name;fpigi_Stroke_Coordinator_Phone', name: 'Stroke Coordinator' },
  { value: 'fpigi_Hospitalist_Lead_Email;fpigi_Hospitalist_Lead_Name;fpigi_Hospitalist_Lead_Phone', name: 'Hospitalist Lead' },
  { value: 'fpigi_ICU_Director_Email;fpigi_ICU_Director_Name;fpigi_ICU_Director_Phone', name: 'ICU Director' },
  { value: 'fpigi_ICU_Medical_Director_Email;fpigi_ICU_Medical_Director_Name;fpigi_ICU_Medical_Director_Phone', name: 'ICU Medical Director' },
  { value: 'fpigi_Pharmacy_Director_Email;fpigi_Pharmacy_Director_Name;fpigi_Pharmacy_Director_Phone', name: 'Pharmacy Director' },
  { value: 'fpigi_Radiology_Director_Email;fpigi_Radiology_Director_Name;fpigi_Radiology_Director_Phone', name: 'Radiology Director' },
  { value: 'fpigi_Credentialing_Contact_Email;fpigi_Credentialing_Contact_Name;fpigi_Credentialing_Contact_Phone', name: 'Credentialing Contact' },
  { value: 'fpigi_IT_Contact_Email;fpigi_IT_Contact_Name;fpigi_IT_Contact_Phone', name: 'IT Contact' },
  { value: 'fpigi_Clinical_Informatics_Contact_Email;fpigi_Clinical_Informatics_Contact_Name;fpigi_Clinical_Informatics_Contact_Phone', name: 'Clinical Informatics Contact' },
  { value: 'fpigi_Accounts_Payable_Contact_Email;fpigi_Accounts_Payable_Contact_Name;fpigi_Accounts_Payable_Contact_Phone', name: 'Accounts Payable Contact' },
  { value: 'fpigi_Billing_Contact_Email;fpigi_Billing_Contact_Name;fpigi_Billing_Contact_Phone', name: 'Billing Contact' },
  { value: 'fpigi_Medical_Records_Deficiencies_Contact_Email;fpigi_Medical_Records_Deficiencies_Contact_Name;fpigi_Medical_Records_Deficiencies_Contact_Phone', name: 'MD.Records (Deficiencies) CP' },
  { value: 'fpigi_Lab_Contact_Email;fpigi_Lab_Contact_Name;fpigi_Lab_Contact_Phone', name: 'Lab Contact' },
  { value: 'fpigi_EMS_Contact_Email;fpigi_EMS_Contact_Name;fpigi_EMS_Contact_Phone', name: 'EMS Contact' }
];

export const createUserTypeOptions = [
  { value: '', name: 'All' },
  { value: 'controller', name: 'Controller' },
  { value: 'accountingManager', name: 'Accounting Manager' },
  { value: 'primaryImplementationContact', name: 'Primary Implementation Contact' },
  { value: 'presidentCEO', name: 'President/CEO' },
  { value: 'cno', name: 'CNO' },
  { value: 'cmo', name: 'CMO' },
  { value: 'erMedicalDirector', name: 'ER Medical Director' },
  { value: 'neuroMedicalDirector', name: 'Neuro Medical Director' },
  { value: 'erDirector', name: 'ER Director' },
  { value: 'strokeCoordinator', name: 'Stroke Coordinator' },
  { value: 'hospitalistLead', name: 'Hospitalist Lead' },
  { value: 'icuDirector', name: 'ICU Director' },
  { value: 'icuMedicalDirector', name: 'ICU Medical Director' },
  { value: 'pharmacyDirector', name: 'Pharmacy Director' },
  { value: 'radiologyDirector', name: 'Radiology Director' },
  { value: 'credentialingContact', name: 'Credentialing Contact' },
  { value: 'itContact', name: 'IT Contact' },
  { value: 'clinicalInformaticsContact', name: 'Clinical Informatics Contact' },
  { value: 'accountsPayableContact', name: 'Accounts Payable Contact' },
  { value: 'billingContact', name: 'Billing Contact' },
  { value: 'mdRecords(Deficiencies)CP', name: 'MD.Records (Deficiencies) CP' },
  { value: 'labContact', name: 'Lab Contact' },
  { value: 'emsContact', name: 'EMS Contact' }
];

export const contactRoleOptions = [
  { code: 0, name: '--Select--' },
  { code: 222, name: 'ED Backup' },
  { code: 221, name: 'ED Main' },
  { code: 224, name: 'Help Desk/ IT' },
  { code: 686, name: 'Main contact' },
  { code: 235, name: 'Nursing Supervisor' },
  { code: 223, name: 'Radiology' },
  { code: 631, name: 'Rounding' }
];

export const selectedQuarterOptions = [
  { code: null, name: 'Select Quarter' },
  { code: '1', name: 'Quarter 1' },
  { code: '2', name: 'Quarter 2' },
  { code: '3', name: 'Quarter 3' },
  { code: '4', name: 'Quarter 4' }
];

export const allStanderdProcessPages = [
  { code: 'EMS', name: 'EMS' },
  { code: 'Inpatient', name: 'INPATIENT' },
  { code: 'Triage/Walk-In', name: 'TRIAGE/WALK-IN' }
]

export const uploadTypeListPre = [
  { Value: '', Text: 'Select Document Type' },
  { Value: 'PreVSM', Text: 'Pre VSM' },
  { Value: 'StandardProcess', Text: 'Standard Process' }
]

export const uploadTypeListPost = [
  { Value: '', Text: 'Select Document Type' },
  { Value: 'PostVSM', Text: 'Post VSM' },
  { Value: 'StandardProcess', Text: 'Standard Process' }
]

/* RCA start */
export const typeOfCorrespondence = [
  { name: 'Email', value: 'email' },
  { name: 'Phone', value: 'phone' },
  { name: 'Text', value: 'text' },
  { name: 'Other', value: 'other' }
];
export const audioOnlyList = [
  { name: 'All', value: '' },
  { name: 'Yes', value: 'true' },
  { name: 'No', value: 'false' }
];
export const statusList = [
  { name: 'Open', value: '17' },
  { name: 'Waiting to Accept', value: '18' },
  { name: 'Accepted', value: '19' },
  { name: 'Complete', value: '20' },
  { name: 'Cancelled', value: '140' }
];
export const folowUpList = [
  { name: 'All', value: '' },
  { name: 'Sign Off', value: 'Sign Off' },
  { name: 'Follow-Up', value: 'Follow-Up' }
];
export const thrombolyticComplicationDropdown = [
  { name: 'ICH', value: 1 },
  { name: 'Angioedema', value: 2 },
  { name: 'GIB', value: 3 },
  { name: 'GUB', value: 4 },
  { name: 'Oral Bleeding', value: 5 },
  { name: 'Other', value: 6 }
];
export const timeFameList = [
  { value: '-1', name: 'Any' },
  { value: 'Today', name: 'Today' },
  { value: 'Yesterday', name: 'Yesterday' },
  { value: 'Last48Hours', name: 'Last 48 Hours' },
  { value: 'LastSevenDays', name: 'Last 7 Days' },
  { value: 'Last30Days', name: 'Last 30 Days' },
  { value: 'PreviousWeek', name: 'Previous Week' },
  { value: 'PreviousMonth', name: 'Previous Month' },
  { value: 'MonthToDate', name: 'Month to Date' },
  { value: 'SpecificDate', name: 'Specific Date' },
  { value: 'DateRange', name: 'Date Range' }
];
export const timeFameListRAPIDiTrending = [
  { value: '-1', name: 'Any' },
  { value: 'Today', name: 'Today' },
  { value: 'Yesterday', name: 'Yesterday' },
  { value: 'Last48Hours', name: 'Last 48 Hours' },
  { value: 'LastSevenDays', name: 'Last 7 Days' },
  { value: 'Last30Days', name: 'Last 30 Days' },
  { value: 'Last60Days', name: 'Last 60 Days' },
  { value: 'Last90Days', name: 'Last 90 Days' },
  { value: 'Last4Month', name: 'Last 4 Months' },
  { value: 'Last6Month', name: 'Last 6 Months' },
  { value: 'PreviousWeek', name: 'Previous Week' },
  { value: 'PreviousMonth', name: 'Previous Month' },
  { value: 'MonthToDate', name: 'Month to Date' },
  { value: 'SpecificDate', name: 'Specific Date' },
  { value: 'DateRange', name: 'Date Range' }
];
export const selectWorkFlowTypeOptions = [
  { Value: 1, Text: 'EMS' },
  { Value: 2, Text: 'Inpatient' },
  { Value: 3, Text: 'Triage/Walk-In' },
  { Value: 4, Text: 'ED Onset' }
];
export const caseTypeOptions = [
  { Value: 9, Text: 'Stroke Alert' },
  { Value: 10, Text: 'STAT Consult' },
  { Value: 11, Text: 'Dr to Dr' },
  { Value: 12, Text: 'Nurse to Dr' },
  { Value: 13, Text: 'STAT EEG' },
  { Value: 14, Text: 'Routine EEG' },
  { Value: 15, Text: 'Long-term EEG' },
  { Value: 163, Text: 'Routine Consult- New' },
  { Value: 164, Text: 'Routine Consult-Follow-Up' },
]
export const eAlertOptions = [
  { Text: 'All', Value: '' },
  { Text: 'Yes', Value: '1' },
  { Text: 'No', Value: '0' }
]
export const thrombolyticsOptions = [
  { name: 'All', value: '' },
  { name: 'Yes', value: '1' },
  { name: 'No', value: '0' }
];
export const qpsReviewOptions = [
  { name: 'All', value: '' },
  { name: 'Yes', value: '1' },
  { name: 'No', value: '0' }
];
export const doortoNeedleTimeOptions = [
  { name: 'All', value: '' },
  { name: '30 to 45 Minutes', value: '1' },
  { name: 'Greater than 45 Minutes', value: '2' }
];
export const cas_nihss_reasonOptions = [
  { name: 'Patient is comatose', value: 1 },
  { name: 'Patient was intubated and paralyzed', value: 2 },
  { name: 'Other', value: 3 }
];

/* Facility PI */
export const selectedFacilityOptions = [
  { value: '', name: 'Select Filter Type' },
  { value: 'facility', name: 'Facility' },
  { value: 'system', name: 'System' },
  { value: 'regional', name: 'Regional' },
  { value: 'state', name: 'State' },
  { value: 'QPS', name: 'QPS' },
  {
    value: 'ByPIParticipationFacility',
    name: 'By Facility Participates in PI Reporting'
  }
];
export const selectReportTypeOptions = [
  { value: '', name: 'Select Report Type' },
  { value: 'daily', name: 'Daily' },
  { value: 'weekly', name: 'Weekly' },
  { value: 'monthly', name: 'Monthly' },
  { value: 'cumulative', name: 'Cumulative' }
];
export const selectActiveOptions = [
  { value: '', name: 'All' },
  { value: 'true', name: 'Active' },
  { value: 'false', name: 'In-Active' }
];
export const ByFacilityParticipatesPIReporting = [
  { Value: '', Text: 'Select Filter Type' },
  { Value: 'true', Text: 'Yes' },
  { Value: 'false', Text: 'No' },
  { Value: 'all', Text: 'All Facility' }
];
export const preArivalOptions = [
  { Value: '0', Text: 'All' },
  { Value: '1', Text: 'Yes' },
  { Value: '2', Text: 'No' }
];
export const spokeSiteOpions = [
  { Value: '0', Text: 'No' },
  { Value: '1', Text: 'Yes' },
  { Value: '2', Text: 'All' }
]
export const workFlow_typeOptions = [
  { Value: '0', Text: 'All' },
  { Value: '1', Text: 'EMS' },
  { Value: '2', Text: 'Inpatient' },
  { Value: '3', Text: 'Triage/Walk-In' },
  { Value: '4', Text: 'ED Onset' }
];

/* Improve */
export const selectedFacilityOptionsImprove = [
  { value: 'facility', name: 'Facility' },
  { value: 'system', name: 'System' },
  { value: 'regional', name: 'Regional' }
];
export const selectReportTypeOptionsImprove = [
  { value: 'monthly', name: 'Monthly' },
  { value: 'quarterly', name: 'Quarterly' }
];
export const selectQuarterOptions = [
  { value: 'quarter1', name: 'Quarter 1' },
  { value: 'quarter2', name: 'Quarter 2' },
  { value: 'quarter3', name: 'Quarter 3' },
  { value: 'quarter4', name: 'Quarter 4' }
];

/* Measure */
export const spokeWithList = [
  { value: 0, name: '-- Select --' },
  { value: 1, name: 'Family' },
  { value: 2, name: 'Patient' },
  { value: 3, name: 'Nurse' },
];

export const object = {
  FieldName: '',
  Value: ''
}

/* Measure */

export const ParticipateInRapidiOptions = [
  { value: "true", Text: 'Yes' },
  { value: "false", Text: 'No' }
];

export const dateTypeOptions = [
  { value: "Date of Consult", Text: 'Date of Consult' },
  { value: "Follow Up Completed", Text: 'Follow Up Completed' }
];

export const actionOptions = [
  { value: '1', Text: 'Completed' },
  { value: '2', Text: 'Successful/Unsuccessful' },
  { value: '3', Text: 'Unsuccessful/Close' }
];